<template>
  <el-row>
    <b v-if="row.name">{{ row.name }}</b>
    <template v-if="!setting.isSimple">
      <template v-if="!readonly">
        <el-row>
          <hic-text-selector v-if="row.rpClass == '检查'" dict-type="BodyParts" @change="(e) => saveChange('parts', e)"
            placeholder="请选择检查部位" v-model="row.parts" multiple class="edit-input right-pad" array-json />
          <hic-text-selector v-if="row.rpClass == '检查'" dict-type="CheckWays" @change="(e) => saveChange('checkWays', e)"
            placeholder="请选择检查方式" v-model="row.checkWays" multiple array-json class="edit-input right-pad" />

          <el-input style="width:10rem;" class="" @blur="saveChange('purpose')" v-model="row.purpose" placeholder="请输入检查目的"
            size="small" clearable></el-input>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-input style="width:30rem;" class="" @blur="saveChange('symptom')" @keydown.enter.native="saveChange"
            v-model="row.symptom" placeholder="请输入临床症状及特征" size="small" clearable></el-input>
        </el-row>
      </template>
      <template v-else>
        <el-row>
          <template v-if="row.rpClass == '检查'">
            <span class="right-pad">
              检查部位：<b class="danger">{{ row.parts | partsFilter }}</b>
            </span>
            <span class="right-pad">
              检查方式：<b class="danger">{{ showCheckWays(row.checkWays) }}</b>
            </span>
          </template>
          <span class="right-pad">
            检查目的：<b class="danger">{{ row.purpose }}</b>
          </span>
        </el-row>
        <el-row>
          <span class="right-pad">
            临床症状及特征：<b class="danger">{{ row.symptom }}</b>
          </span>
        </el-row>
      </template>
    </template>
    <!-- <el-tag type="info" hit v-if="isGroup && isMaster" style="border-left: gray 90px solid" class="top-pad">
      <span style="margin: 0 10px 0 -90px; color: white">输液【{{ row.groupNo }}】</span>
      <span v-if="isMaster" class="left-pad">
        <b>频次：</b><b :class="isMaster ? 'danger' : 'info'">{{ row.frequency | dictText("DrugFrequency") }}</b>
      </span>
      <span v-if="isMaster" class="left-pad">
        <b>周期：</b><b :class="isMaster ? 'danger' : 'info'">{{ row.days }}</b>
      </span>
      <span v-if="isMaster" class="left-pad">
        <b>滴速：</b><b :class="isMaster ? 'danger' : 'info'">{{ row.dropSpeed }} 滴/分</b>
      </span>
    </el-tag> -->
  </el-row>
</template>
<script>
import { mapGetters } from "sw-hic";
export default {
  props: {
    row: Object,
    readonly: Boolean,
  },
  data() {
    return {
      option: {
        loading: false,
        selectedItem: null,
        items: [],
        condition: {
          keyword: null,
          pageSize: 50,
          pageIndex: 0,
        },
      },
    };
  },
  filters: {
    partsFilter(val) {
      try {
        val = JSON.parse(val).join(",")
        return val
      } catch (error) {
        return val
      }
    }
  },
  computed: {
    ...mapGetters(["dict", "setting"]),
  },
  mounted() {
    if (!this.readonly && !this.row.id) {
      this.$emit("addnew", this.row);
    }
  },
  methods: {
    saveChange(key, val) {
      this.$nextTick(() => {
        if (this.row.id) {
          let obj = {
            id: this.row.id
          }
          if (val) obj[key] = val
          else obj[key] = this.row[key]

          this.$emit('saveAdvice', this.row, obj)
        } else {
          this.$emit("addnew", this.row);
        }
      });
    },
    showCheckWays(checkWays) {
      if (!checkWays) return
      try {
        checkWays = JSON.parse(checkWays)
        return checkWays.join(",")
      } catch (error) {
        return checkWays
      }
    }
  },
};
</script>
